import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** Whether a quiz was found for this step */
  hasQuiz: boolean;
  /** Quiz content (rendered when hasQuiz is true) */
  children?: React.ReactNode;
};

/**
 * Presentational org quiz step.
 * Shows quiz content when available, or an error state when no quiz is configured.
 */
export function OrgQuizStep({ hasQuiz, children }: Props) {
  if (!hasQuiz) {
    return (
      <div className="w-full flex flex-col gap-6 p-6 max-w-3xl mx-auto">
        <div className="flex flex-col gap-2">
          <Type variant="h2">Onboarding Quiz</Type>
          <Type variant="body1" className="text-brand-700">
            No quiz has been configured for this step.
          </Type>
        </div>

        <Type variant="body1" className="text-brand-700">
          Quiz not found. You may skip this step.
        </Type>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col flex-1">
      {children}
    </div>
  );
}

export default OrgQuizStep;
